export const PLACEHOLDER_DOCUMENT_ID = "<FLASHDOCS_DASHBOARD>";
export const FLASHDOCS_USER_CACHE_KEY = "fl-server-user";
